import type { Technician } from '@/types'

export function suggestedTechnicianName(
  technician: Pick<Technician, 'first_name' | 'full_name'>
): string {
  const firstName = technician.first_name?.trim()
  if (firstName) return firstName

  return (
    technician.full_name.trim().split(/\s+/).filter(Boolean)[0] ??
    technician.full_name
  )
}
